import { TMainPageLayoutV3 } from "../type";


const MNPG041 = ( props: TMainPageLayoutV3 ) => {
    console.log("MNPG041.rendered: ", props);
    return null;
}

export default MNPG041;
